import { render, staticRenderFns } from "./VAssetForm.vue?vue&type=template&id=4abaa30b&"
import script from "./VAssetForm.vue?vue&type=script&lang=js&"
export * from "./VAssetForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports